import { PayloadAction } from '@reduxjs/toolkit';
import { AuthState } from './authState';
import { IRefreshTokenResponse, refreshToken, overrideSession } from './refreshToken.thunks';

const reducers = {
  [refreshToken?.pending.type]: (state: AuthState): void => {
    state.loading = true;
  },
  [refreshToken?.fulfilled.type]: (state: AuthState, action: PayloadAction<IRefreshTokenResponse>): void => {
    state.loading = false;
    state.token = action.payload.token;
  },
  [refreshToken?.rejected.type]: (state: AuthState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
  },
  [overrideSession?.pending.type]: (state: AuthState): void => {
    state.loading = true;
  },
  [overrideSession?.fulfilled.type]: (state: AuthState): void => {
    state.loading = false;
    state.uniqueSession = true;
  },
  [overrideSession?.rejected.type]: (state: AuthState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
  }
};

export default reducers;